import { Button, Card, CardActions, CardContent, CardHeader, Checkbox, FormControlLabel, Grid, TextField } from "@mui/material"
import { useState } from "react";


export const ProfileDataView = ({ userData }: any) => {
    const [isEditing, setIsEditing] = useState(false);

    const toggleEdit = () => {
        setIsEditing(!isEditing);
    };



    return (
        <Grid>

            <CardHeader
                title="Información de perfil"
                titleTypographyProps={{ variant: 'h6', fontWeight: 'bold' }}
                sx={{
                    borderBottom: 2,
                    borderColor: 'divider',
                    paddingBottom: '8px', // Ajustar según necesidad
                    '& .MuiCardHeader-title': { // Asegúrate de que el título tenga el margen adecuado
                        marginBottom: '8px',
                    },
                }}
            />
            <CardContent>
                <TextField
                    label="Nombre completo"
                    variant={isEditing ? 'outlined' : 'standard'} // Cambia 'filled' por 'standard' si prefieres un borde más delgado
                    fullWidth
                    color="secondary"
                    margin="normal"
                    defaultValue={userData.fullName}
                    InputProps={{
                        readOnly: !isEditing,
                    }}
                />
                <TextField
                    label="Contraseña"
                    variant={isEditing ? 'outlined' : 'standard'}
                    fullWidth
                    color="secondary"
                    margin="normal"
                    defaultValue="********"
                    type="password"
                    InputProps={{
                        readOnly: !isEditing,
                    }}
                />
                <TextField
                    label="Correo electrónico"
                     variant={isEditing ? 'outlined' : 'standard'}
                    fullWidth
                    color="secondary"
                    margin="normal"
                    defaultValue={userData.email}
                    InputProps={{
                        readOnly: !isEditing,
                    }}
                />
                <TextField
                    label="Teléfono"
                     variant={isEditing ? 'outlined' : 'standard'}
                    fullWidth
                    color="secondary"
                    margin="normal"
                    defaultValue={userData.phone}
                    InputProps={{
                        readOnly: !isEditing,
                    }}
                />
                <TextField
                    label="Fecha de Nacimiento"
                     variant={isEditing ? 'outlined' : 'standard'}
                    fullWidth
                    color="secondary"
                    margin="normal"
                    defaultValue={userData.birthDate}
                    type="date"
                    InputProps={{
                        readOnly: !isEditing,
                    }}
                    InputLabelProps={{ shrink: true }}
                />
            </CardContent>
            <CardActions  disableSpacing sx={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                <FormControlLabel 
                    control={<Checkbox color="secondary" defaultChecked />}
                    label="Acepto recibir publicidad de TICOTICKET"
                />
                <Button variant="contained" color="secondary" onClick={toggleEdit} sx={{ width: '20%', marginTop: 1 }}>
                    {isEditing ? 'Guardar' : 'Editar'}
                </Button>
            </CardActions>
        </Grid>
    )
}
